import axios from "axios";
import router from "./router";
import { showError } from "./services/alert.service";

/** Configuracion HTTP de toda la app. Antes no habia interceptor: un 401 terminaba en un console.log con el loader colgado. */

/** Timeout alto a proposito: el listado consulta Mercado Libre una vez por orden, ~40s para una pagina de 30. */
export const GLOBAL_TIMEOUT = 180000;

/** Las llamadas que no dependen de Mercado Libre (config, acciones puntuales). */
export const DEFAULT_TIMEOUT = 30000;

/** Las de lote procesan hasta 30 ordenes contra Mercado Libre. */
export const BATCH_TIMEOUT = 120000;

const goToGuest = () => {
  // vue-router 3 rechaza la navegacion duplicada si ya estamos ahi.
  if (router.currentRoute.name === "guest-page") return;
  router.push("/guest").catch(() => {});
};

/** `skipAuthRedirect: true` desactiva el manejo de 401/419: en el login un rechazo de credenciales no es una sesion vencida. */
const handleError = (error) => {
  const status = error.response && error.response.status;
  const config = error.config || {};

  if (error.code === "ECONNABORTED") {
    showError({
      message: "La operación tardó demasiado y se canceló. Verificá si se completó antes de reintentar.",
    });
  } else if ((status === 401 || status === 419) && !config.skipAuthRedirect) {
    // 401: sesion vencida. 419: token CSRF vencido o rotado.
    showError({ message: "Tu sesión expiró. Volvé a ingresar." });
    goToGuest();
  } else if (!error.response) {
    showError({ message: "No se pudo conectar con el servidor." });
  }

  return Promise.reject(error);
};

/** Las instancias creadas con axios.create() no heredan los interceptors del default. */
export const attachInterceptors = (client) => {
  client.interceptors.response.use((response) => response, handleError);
  return client;
};

// --- Configuracion global ----------------------------------------------------
// Alcanza a todos los componentes, que hoy importan `axios` pelado directamente.
axios.defaults.withCredentials = true;
axios.defaults.timeout = GLOBAL_TIMEOUT;
attachInterceptors(axios);

// --- Cliente de los services -------------------------------------------------
// baseURL propio y timeout mas corto: estas llamadas no pasan por Mercado Libre.
const http = attachInterceptors(
  axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    withCredentials: true,
    timeout: DEFAULT_TIMEOUT,
  })
);

/** Mensaje de error legible. Los endpoints Flex devuelven { success:false, error_code, message }. */
export const errorMessage = (error, fallback = "Ocurrió un error. Reintentalo.") => {
  const data = error && error.response && error.response.data;
  if (!data) return fallback;
  if (data.message) return data.message;
  if (data.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first.length) return first[0];
  }
  return fallback;
};

export default http;
